import { html } from "lit";

export const tikTokIcon = (theme: string) => html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="${theme === "purple" ? "twf-fill-white" : "twf-fill-[#282828]"}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8688 3.20711C12.007 2.64503 11.3848 1.74608 11.1909 0.698056C11.1489 0.471515 11.126 0.238563 11.126 0H8.37514L8.3706 11.0241C8.32438 12.2586 7.30842 13.2494 6.06271 13.2494C5.67562 13.2494 5.31096 13.1527 4.99012 12.9836C4.25412 12.5963 3.75055 11.8248 3.75055 10.937C3.75055 9.66192 4.78788 8.62459 6.06271 8.62459C6.30074 8.62459 6.52889 8.66386 6.74501 8.73145V5.9232C6.52141 5.89274 6.29433 5.87377 6.06271 5.87377C3.27129 5.87404 1 8.14533 1 10.937C1 12.65 1.85594 14.1658 3.16149 15.0823C3.98377 15.6597 4.98424 16 6.06298 16C8.85467 16 11.126 13.7287 11.126 10.937V5.34696C12.2047 6.12142 13.5265 6.57771 14.9528 6.57771V3.82689C14.1845 3.82689 13.4688 3.59848 12.8688 3.20711Z"
    />
  </svg>
`;
